/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Favoriten verwalten
 * 
 * Hier kann der Benutzer seine Favoriten verwalten.
 * 
 * Favoriten können für jeden Katalog separat verwaltet werden.
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { IconPortfolio } from "../../partials/Icons";
import ProductDetails from "../product/ProductDetails";
import PDFFrame from "../../partials/PDFFrame";
import { ConfirmModal } from "../../partials/ConfirmModal";
import { Icon } from '../../partials/Icons';
import * as utils from "../../../basics/utils";
import * as cordova from "../../../basics/cordova";
import * as appActions from "../../../store/actions/appActions";
import * as portfolioActions from "../../../store/actions/portfolioActions";
import { ImageLoader } from "../../partials/ImageLoader";

class FavoredController extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, headerHeight, toolbarType, orientation, appModus, favoredList, currentContainer, modalDialog } = this.props.app;
        const itemHeight = (orientation === 'landscape') ? inputHeight / 4 : inputHeight / 6;

        const items = utils.getFavourList();

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        /**
         * Diese Funktion zeigt einen einzelnen Favoriten in einer Zeile 
         */
        const renderItem = (d, i) => {

            /**
             * Klick eine Zeile (nicht PDF-Image)
             * Wenn der Benutzer eine Zeile der Liste anklickt, dann wird
             * die Detailseite des Produktes angezeigt.
             */
            const onClick = () => {
                this.props.setFavoredIndex(i, d.path); // appAction.js
                // immer wenn der Pfad gesetzt wird muss auch...

                // currentProduct aktualisiert werden
                this.props.setCurrentProduct(d); // appAction.js

                // currentPortfolio aktualisiert werden
                const dialog = utils.getDialogByPath(d.path);
                const changePortfilio = utils.getPortfolio(dialog.portfolio);
                this.props.setCurrentPortfolio(changePortfilio); // appAction.js
            }

            /**
             * Hier wird das Favoriten-Icon (Stern) angezeigt.
             * Klickt der Benutzer auf das Icon, dann wird das Produkt
             * aus der Liste der Favoriten gelöscht.
             */
            const renderIconStar = () => {

                const onDelete = () => {
                    this.props.setModalDialog('ConfirmModal', 'deleteFavored', d.path);
                }

                const style = utils.getStyleHeight(itemHeight, .5, .5, .5);

                return (
                    <div style={style} className="w-full ml-0 flex items-center " onClick={onDelete}>
                        <Icon type='star_filled' width={itemHeight * .5} height={itemHeight * .25} />
                    </div>
                )
            }

            /**
             * Hier wird das Freisteller-Bild des Produktes angezeigt.
             */
            const renderImageFree = (d) => {

                const fileObj = utils.getFileInNode(d.children, 'free');
                if (!fileObj) return null;

                return (<ImageLoader path={fileObj.path} name={fileObj.name} height={'100%'} cover={'75%'} />)
            }

            // ###############################################################
            // renderItem()
            // ###############################################################
            const dialog = utils.getDialogByPath(d.path);
            const portfolio = utils.getPortfolio(dialog.portfolio);

            const style = {
                color: 'black',
                marginBottom: '4px',
                backgroundColor: (i % 2) ? 'rgb( 241, 241, 241)' : 'transparent',
                ...utils.getStyleHeight(itemHeight, 1.0, 1.0, 0.5),
            }

            return (
                <div key={i} className="w-full flex" style={style}>
                    <div className="w-1/5 flex items-center justify-center" onClick={onClick}>
                        {renderImageFree(d)}
                    </div>
                    <div className="w-1/5 flex items-center justify-center" onClick={onClick}>
                        <ProductDetails node={d} height={itemHeight * 0.2} version='left' />
                    </div>
                    <div className="w-1/5 flex items-center justify-center" onClick={onClick}>
                        {IconPortfolio(portfolio, itemHeight, null)}
                    </div>
                    <div className="w-1/5 flex items-center justify-center" >
                        <PDFFrame node={d} type='product' listView={true} />
                    </div>
                    <div className="w-1/5 flex items-center justify-start">
                        {renderIconStar()}
                    </div>
                </div>
            )
        }

        /**
         * Hier wird der Bestätigungsdialog angezeigt, indem der Benutzer das Löschen eines
         * Favoriten bestätigen muss.
         */
        const renderDeleteFavoredConfirm = () => {

            const onConfirm = () => {
                const deletePath = modalDialog.details;

                const newFavoredList = favoredList.filter(value => value !== deletePath);

                // neue Favoritenliste im REDUX-Store speichern
                this.props.setFavoredList(newFavoredList); // appAction.js

                // neue Favoritenliste in IndexedDB speichern
                cordova.writeLocalJSON(currentContainer, 'favored.json', newFavoredList);

                this.props.closeModalDialog(); // appAction.js
            }

            const onCancel = () => {
                this.props.closeModalDialog(); // appAction.js
            }

            return (
                <ConfirmModal dialog='ConfirmModal' type='deleteFavored' title="Bestätigung" onConfirm={onConfirm} onCancel={onCancel}>
                    <div className="flex justify-start text-2xl font-bold">Favorit löschen?</div>
                </ConfirmModal>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            top: headerHeight + 'px',
            height: inputHeight + 'px',
            minHeight: inputHeight + 'px',
            backgroundColor: 'white',
        }

        if (appModus === 'Admin' || toolbarType !== 'favored') return null;

        return (
            <div className="Favored w-full flex z-40" style={style}>
                <div className="w-full flex flex-col text-white">
                    <div className="w-full flex overflow-y-auto">
                        <div className="w-10/12 flex flex-col overflow-x-hidden mx-auto">
                            {items.map((d, i) => renderItem(d, i))}
                        </div>
                    </div>
                </div>
                {renderDeleteFavoredConfirm()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FavoredController);
